import React, { useState, useEffect } from "react";

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // show offline on initial load if offline
    if (!navigator.onLine) {
      setIsOnline(false);
      setVisible(true);
    }

    const handleOnline = () => {
      setIsOnline(true);
      setVisible(true);
      // auto-dismiss after short time when back online
      setTimeout(() => setVisible(false), 2500);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setVisible(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleClose = () => setVisible(false);

  if (!visible) return null;

  return (
    <div
      className={`nb-network-toast ${isOnline ? "online" : "offline"} ${visible ? "show" : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="nb-network-inner">
        <div className="nb-network-icon" aria-hidden>
          {isOnline ? "✅" : "⚠️"}
        </div>

        <div className="nb-network-text">
          {isOnline ? "Back Online" : "No Internet Connection"}
        </div>

        {!isOnline && (
          <button
            className="nb-network-close"
            aria-label="Close notification"
            onClick={handleClose}
            title="Close"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default NetworkStatus;
